/**
 * Trang "Điện năng" — TK-33b (lee 22/10 chiều): mục menu thứ 6 của mẫu chạy được. kWh theo ngày = cuối − đầu bộ đếm điện năng
 * của công tơ, cộng các tủ ĐÃ BIẾT (services/diennang.ts · dienNangGop.ts). KA-49: mọi phạm vi đọc `GET /api/dien-nang/thong-ke`
 * (+ `/api/dien-nang/nang-luong` cho đèn NEMA / công suất / đêm qua) — `/api/dien-nang/ngay` vẫn còn trên máy chủ, trang không gọi nữa.
 *
 * ⛔ LUẬT SỐ 0: ngày không tủ nào đo được ⇒ ô "—" và KHÔNG có cột (không cột 0); cả khoảng không có số ⇒ "Chưa có số đo".
 *   Mỗi ngày nói rõ bao nhiêu tủ góp / bao nhiêu tủ thiếu số — con số tổng không được trông như của cả khu khi nó không phải.
 */
import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTree } from '../lib/queries';
import { useDatDoiTuong } from '../lib/doiTuongDangChon';
import { CayNangLuong, OThongKe, useNangLuong, useThongKe, type ChonNL } from '../components/thongke/OThongKe';

/**
 * TK-38 việc 6 (lee 23/10): trái cây Tuyến → Tủ (+ tìm), phải ô thống kê của mục chọn (`OThongKe`). Mục chọn sống trong URL (`?tuyen=&tu=`).
 * KA-49 §5 (mẫu lee duyệt `mau_nang_luong`): cây có kWh 30 ngày + cấp ĐÈN NEMA (`?den=<addr>`); MỌI phạm vi (toàn khu · tuyến · tủ ·
 *   đèn) dùng CÙNG `OThongKe` — toàn khu đọc `/api/dien-nang/thong-ke` không tham số (cùng phạm vi tài khoản + tủ vận hành).
 */
export default function DienNangPage() {
  useEffect(() => { document.title = 'Thống kê năng lượng — SDKD'; }, []);
  const cay = useTree();
  const [thamSo, datThamSo] = useSearchParams();
  const denSo = thamSo.get('den');
  const chon: ChonNL = { tuyen: thamSo.get('tuyen'), tu: thamSo.get('tu'), den: denSo !== null && /^\d+$/.test(denSo) ? Number(denSo) : null };
  const onChon = (c: ChonNL) => { const p: Record<string, string> = {}; if (c.tuyen) p.tuyen = c.tuyen; if (c.tu) p.tu = c.tu; if (c.tu && c.den != null) p.den = String(c.den); datThamSo(p); };
  const r = (cay.data ?? []).find((x) => x.id === chon.tuyen) ?? null;
  const ten = chon.tu ? r?.cabinets.find((c) => c.id === chon.tu)?.name ?? 'Tủ' : r?.tenDayDu ?? '';
  useDatDoiTuong({ tuyen: r?.tenDayDu, tu: chon.tu ? r?.cabinets.find((c) => c.id === chon.tu)?.name : null });   // TK-45 §2
  /* KA-49: số cho cây (kWh 30 ngày theo tủ + đèn NEMA) — truy vấn TOÀN KHU, cùng khoá với ô toàn khu (một lần tải) */
  const tkToan = useThongKe('');
  const nlToan = useNangLuong('');
  const kwhTu = useMemo(() => {
    const t = tkToan.data?.theoTuNgay; if (!t) return undefined;
    return new Map(Object.entries(t).map(([id, ds]) => { const v = ds.filter((x): x is number => x !== null); return [id, v.length ? v.reduce((a, b) => a + b, 0) : null]; }));
  }, [tkToan.data]);
  return (
    <div className="space-y-4" data-trang="dien-nang">
      <h1 className="chu-tieude m-0 text-[26px] font-semibold leading-tight text-chu-1">Thống kê năng lượng</h1>
      <div className="grid grid-cols-[minmax(0,1fr)] gap-4 lg:grid-cols-[280px_minmax(0,1fr)]">
        <CayNangLuong cay={cay.data ?? []} chon={chon} onChon={onChon} kwhTu={kwhTu} den={nlToan.data?.den ?? []} />
        <div className="min-w-0">{chon.tu || chon.tuyen ? <OThongKe key={`${chon.tuyen}|${chon.tu}|${chon.den ?? ''}`} chon={chon} ten={ten} /> : <ToanKhu />}</div>
      </div>
    </div>
  );
}

/** Toàn khu — KA-49: cùng `OThongKe` (thay khối 7/30 ngày đọc `/api/dien-nang/ngay` của TK-33b; mọi số cũ vẫn có: hôm qua · tuần trước ·
 *   tổng N ngày · x / N ngày có số · số tủ phạm vi · bảng ngày với tủ góp / tủ thiếu). */
function ToanKhu() {
  return <OThongKe chon={{ tuyen: null, tu: null, den: null }} ten="Toàn khu" />;
}
